class MainMenu {
    constructor() {

        this.mainMenu = document.querySelector(".mainmenu")

    };

    close = () => {
        this.mainMenu.querySelector('.close-btn').addEventListener('click', (e) => {
            // this.mainMenu.style.width = "0";
            this.mainMenu.querySelector('nav').classList.remove('toggle');
        })
    };

    toggle = () => {
        this.mainMenu.querySelector('.mainmenu__header').addEventListener('click', (e) => {
            // this.mainMenu.style.width = "0";
            this.mainMenu.querySelector('nav').classList.toggle('toggle');
        })
    };
}